import {Component, HostBinding, Inject, OnInit, ChangeDetectionStrategy} from '@angular/core';

import {Mixture} from "../../data/mixtures";
import {DIALOG_DATA, DialogRef} from "@angular/cdk/dialog";
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import CryptoJS from 'crypto-js';

@Component({
    selector: 'app-order',
    imports: [ReactiveFormsModule],
    templateUrl: './order.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './order.component.scss'
})
export class OrderComponent implements OnInit {
  lang: 'de'|'en' = document.location.href.match( /\/de\// ) ? 'de' : 'en'
  submitted = false
  showSuccess = false
  @HostBinding('style.padding') get getPadding() {
    return this.showSuccess ? '0' : '50px'
  }
  form = new FormGroup({
    product_name: new FormControl('', [Validators.required]),
    propane: new FormControl('', [Validators.required]),
    isobutane: new FormControl('', [Validators.required]),
    butane: new FormControl('', [Validators.required]),
    bar: new FormControl('', [Validators.required]),

    sample_usecase: new FormControl('', [Validators.required]),
    annual_demand: new FormControl('', [Validators.required]),
    company: new FormControl('', [Validators.required]),
    department: new FormControl('', [Validators.required]),
    street: new FormControl('', [Validators.required]),
    additional: new FormControl('', []),
    zipcode: new FormControl('', [Validators.required]),
    city: new FormControl('', [Validators.required]),
    country: new FormControl('', [Validators.required]),
    contact: new FormControl('', [Validators.required]),
    phone: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.email]),
    further: new FormControl('', []),
    from: new FormControl('')
  })

  countries = [
    {value: 'Albania', label: $localize`Albania`},
    {value: 'Andorra', label: $localize`Andorra`},
    {value: 'Armenia', label: $localize`Armenia`},
    {value: 'Austria', label: $localize`Austria`},
    {value: 'Azerbaijan', label: $localize`Azerbaijan`},
    {value: 'Belarus', label: $localize`Belarus`},
    {value: 'Belgium', label: $localize`Belgium`},
    {value: 'Bosnia and Herzegovina', label: $localize`Bosnia and Herzegovina`},
    {value: 'Bulgaria', label: $localize`Bulgaria`},
    {value: 'Croatia', label: $localize`Croatia`},
    {value: 'Cyprus', label: $localize`Cyprus`},
    {value: 'Czech Republic', label: $localize`Czech Republic`},
    {value: 'Denmark', label: $localize`Denmark`},
    {value: 'Estonia', label: $localize`Estonia`},
    {value: 'Finland', label: $localize`Finland`},
    {value: 'France', label: $localize`France`},
    {value: 'Georgia', label: $localize`Georgia`},
    {value: 'Germany', label: $localize`Germany`},
    {value: 'Greece', label: $localize`Greece`},
    {value: 'Hungary', label: $localize`Hungary`},
    {value: 'Iceland', label: $localize`Iceland`},
    {value: 'Ireland', label: $localize`Ireland`},
    {value: 'Italy', label: $localize`Italy`},
    {value: 'Kazakhstan', label: $localize`Kazakhstan`},
    {value: 'Latvia', label: $localize`Latvia`},
    {value: 'Liechtenstein', label: $localize`Liechtenstein`},
    {value: 'Lithuania', label: $localize`Lithuania`},
    {value: 'Luxembourg', label: $localize`Luxembourg`},
    {value: 'Macedonia', label: $localize`Macedonia`},
    {value: 'Malta', label: $localize`Malta`},
    {value: 'Moldova', label: $localize`Moldova`},
    {value: 'Monaco', label: $localize`Monaco`},
    {value: 'Montenegro', label: $localize`Montenegro`},
    {value: 'Netherlands', label: $localize`Netherlands`},
    {value: 'Norway', label: $localize`Norway`},
    {value: 'Poland', label: $localize`Poland`},
    {value: 'Portugal', label: $localize`Portugal`},
    {value: 'Romania', label: $localize`Romania`},
    {value: 'Russia', label: $localize`Russia`},
    {value: 'San Marino', label: $localize`San Marino`},
    {value: 'Serbia', label: $localize`Serbia`},
    {value: 'Slovakia', label: $localize`Slovakia`},
    {value: 'Slovenia', label: $localize`Slovenia`},
    {value: 'Spain', label: $localize`Spain`},
    {value: 'Sweden', label: $localize`Sweden`},
    {value: 'Switzerland', label: $localize`Switzerland`},
    {value: 'Turkey', label: $localize`Turkey`},
    {value: 'Ukraine', label: $localize`Ukraine`},
    {value: 'United Kingdom', label: $localize`United Kingdom`},
    {value: 'Vatican City', label: $localize`Vatican City`},
  ]

  constructor(@Inject(DIALOG_DATA) public data: {product: Mixture, mode: 'mixing'|'pressure'},
              private dialogRef: DialogRef,
              private httpClient: HttpClient) {
  }

  ngOnInit() {
    this.patchProduct(this.data.product, this.data.mode)
  }

  encrypt(message: string) {
    const password = CryptoJS.enc.Latin1.parse("drivosol".padEnd(32, '\0'))
    const iv = CryptoJS.enc.Latin1.parse("0123456789abcdef")
    return CryptoJS.AES.encrypt(message, password, {iv}).toString()
  }

  createValidationString() {
    const date = new Date().getTime()
    return this.encrypt(`${date};${this.form.value.email}`)
  }

  patchProduct(product: Mixture, mode: 'mixing'|'pressure') {
    this.form.patchValue({
      product_name: `Drivosol® ${product.name}`,
      propane: product.propane.toLocaleString(this.lang, {minimumFractionDigits: 1}) + ' %',
      isobutane: product.isobutane.toLocaleString(this.lang, {minimumFractionDigits: 1}) + ' %',
      butane: product.butane.toLocaleString(this.lang, {minimumFractionDigits: 1}) + ' %',
      bar: product.bar.toLocaleString(this.lang, {minimumFractionDigits: 1}),
      from: mode === 'mixing' ? 'By mixture' : 'By pressure'
    })
  }

  send() {
    this.submitted = true

    if (this.form.invalid) {
      return
    }

    const formData = new FormData()

    formData.set('validation-string', this.createValidationString())

    for (const [key, value] of Object.entries(this.form.value)) {
      if (value) {
        formData.set(key, value)
      }
    }

    this.httpClient.post('/mail/', formData).subscribe({
      next: (response) => {
        const r = response as {success: boolean, message: string}

        if (r.success) {
          this.showSuccess = true

        } else {
          alert(r.message)
          this.closeDialog()
        }
      },
      error: (errorResponse: HttpErrorResponse) => {
        alert(errorResponse.error.message)
        this.closeDialog()
      }
    })
  }

  hasError() {
    return this.form.invalid && this.submitted
  }

  hasFieldError(name: string) {
    return this.form.get(name)!.invalid && this.submitted
  }

  closeDialog() {
    this.dialogRef.close()
  }
}
